import React, { useEffect, useState } from "react";
import { Avatar, Input, Select, Space, Statistic, Table, Tag, message } from "antd";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Locale } from "../../utils";
import { getUserInfo } from "../../utils/redux/reducers/User";
import ApiManager from "../../utils/api/ApiManager";

const i18n = Locale.getInstance();
const api = ApiManager.getInstance().groupon;

const STATUS_OPTIONS = [
  { value: "-1", label: i18n.t("groupon.all") },
  { value: "0", label: i18n.t("groupon.statusPending") },
  { value: "1", label: i18n.t("groupon.statusPaid") },
  { value: "2", label: i18n.t("groupon.statusRedeemed") },
  { value: "3", label: i18n.t("groupon.statusRefunded") },
];

function OrderList() {
  const user = useSelector((state) => getUserInfo(state));
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState({ data: [] });
  const [keyword, setKeyword] = useState("");
  const [status, setStatus] = useState("-1");

  const load = async (page = 1) => {
    if (!user.token) return;
    setLoading(true);
    try {
      const res = await api.orderList.run({
        token: user.token,
        query: { page, count: 20, keyword, status },
      });
      if (res.result) {
        setOrders(res.data);
      } else {
        message.warning(res.message);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [status]);

  const columns = [
    {
      title: i18n.t("order.orderNo"),
      dataIndex: "order_no",
      width: 200,
    },
    {
      title: i18n.t("member.info"),
      render: (_, record) =>
        record.user ? (
          <Space>
            <Avatar src={record.user.avatar} />
            <span>{record.user.nickname || record.user.mobile}</span>
          </Space>
        ) : null,
    },
    {
      title: i18n.t("groupon.deal"),
      render: (_, record) =>
        record.product_snapshot
          ? i18n.getPropNameByLocale(record.product_snapshot)
          : "-",
    },
    {
      title: i18n.t("groupon.cash"),
      render: (_, record) => (
        <Statistic prefix="¥" precision={2} value={record.cash_amount / 100} />
      ),
      width: 120,
    },
    {
      title: i18n.t("order.status"),
      dataIndex: "status",
      width: 120,
      render: (value) => <Tag>{i18n.t(`groupon.statusLabel.${value}`)}</Tag>,
    },
    {
      title: i18n.t("common.action"),
      width: 100,
      render: (_, record) => (
        <a onClick={() => history.push(`/main/groupon/orders/${record.id}`, { order: record })}>
          {i18n.t("groupon.detail")}
        </a>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Space style={{ marginBottom: 16 }}>
        <Input.Search
          allowClear
          placeholder={i18n.t("groupon.search")}
          onSearch={() => load()}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <Select value={status} options={STATUS_OPTIONS} onChange={setStatus} style={{ width: 160 }} />
      </Space>
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={orders.data || []}
        pagination={{
          current: orders.current_page,
          total: orders.total,
          pageSize: orders.per_page || 20,
          onChange: load,
        }}
      />
    </div>
  );
}

export default OrderList;
